<nz-modal
    [(nzVisible)]="visible"
    nzTitle="Update Payment Status"
    (nzOnCancel)="closeModal()"
>
    <div *nzModalContent>
        <div class="mb-4">
            <p class="mb-4 text-gray-600">
                <strong>Warning:</strong> This will manually override the
                payment status.
            </p>

            <div class="mb-4">
                <label class="block mb-2 text-sm font-medium"
                    >Payment Status: <span class="text-red-500">*</span></label
                >
                <nz-select
                    [(ngModel)]="selectedPaymentStatus"
                    class="w-full"
                    nzPlaceHolder="Select Payment Status"
                >
                    <nz-option
                        *ngFor="let status of paymentStatusOptions"
                        [nzValue]="status[0]"
                        [nzLabel]="status[1].name"
                    ></nz-option>
                </nz-select>
            </div>

            <div class="mb-4" *ngIf="selectedPaymentStatus !== 'skipped'">
                <label class="block mb-2 text-sm font-medium"
                    >Payment ID:</label
                >
                <input
                    type="text"
                    nz-input
                    [(ngModel)]="paymentFormData.paymentId"
                    placeholder="Enter payment ID (e.g., Stripe payment intent ID)"
                    class="w-full"
                />
            </div>

            <div class="mb-4" *ngIf="selectedPaymentStatus !== 'skipped'">
                <label class="block mb-2 text-sm font-medium">Amount:</label>
                <nz-input-number
                    [(ngModel)]="paymentFormData.amount"
                    [nzMin]="0"
                    [nzStep]="0.01"
                    [nzPrecision]="2"
                    class="w-full"
                    placeholder="Payment amount"
                ></nz-input-number>
            </div>

            <!-- Failed-specific fields -->
            <div class="mb-4" *ngIf="selectedPaymentStatus === 'failed'">
                <label class="block mb-2 text-sm font-medium"
                    >Failed Reason:</label
                >
                <textarea
                    nz-input
                    [(ngModel)]="paymentFormData.failedReason"
                    placeholder="Enter reason for payment failure"
                    class="w-full"
                    rows="3"
                ></textarea>
            </div>

            <!-- Refund-specific fields -->
            <div
                class="mb-4"
                *ngIf="
                    selectedPaymentStatus === 'refunded' ||
                    selectedPaymentStatus === 'partially_refunded'
                "
            >
                <div class="mb-3">
                    <label class="block mb-2 text-sm font-medium"
                        >Refund ID:</label
                    >
                    <input
                        type="text"
                        nz-input
                        [(ngModel)]="paymentFormData.refundId"
                        placeholder="Enter refund ID"
                        class="w-full"
                    />
                </div>
                <div class="mb-3">
                    <label class="block mb-2 text-sm font-medium"
                        >Refund Amount (Total):</label
                    >
                    <nz-input-number
                        [(ngModel)]="paymentFormData.refundAmount"
                        [nzMin]="0"
                        [nzStep]="0.01"
                        [nzPrecision]="2"
                        class="w-full"
                        placeholder="Refund amount"
                    ></nz-input-number>
                </div>
                <div class="mb-3">
                    <label class="block mb-2 text-sm font-medium"
                        >Refunded Credit Amount:</label
                    >
                    <nz-input-number
                        [(ngModel)]="paymentFormData.refundedCreditAmount"
                        [nzMin]="0"
                        [nzStep]="0.01"
                        [nzPrecision]="2"
                        class="w-full"
                        placeholder="Refunded credit amount"
                    ></nz-input-number>
                </div>
                <div>
                    <label class="block mb-2 text-sm font-medium"
                        >Returned Post-Purchase Credit:</label
                    >
                    <nz-input-number
                        [(ngModel)]="paymentFormData.returnedPostPurchaseCredit"
                        [nzMin]="0"
                        [nzStep]="0.01"
                        [nzPrecision]="2"
                        class="w-full"
                        placeholder="Returned post-purchase credit"
                    ></nz-input-number>
                </div>
            </div>

            <!-- Delayed capture field -->
            <div
                class="mb-4"
                *ngIf="selectedPaymentStatus === 'delayed_capture' || selectedPaymentStatus === 'partial_paid'"
            >
                <label class="block mb-2 text-sm font-medium"
                    >Delayed Amount:</label
                >
                <nz-input-number
                    [(ngModel)]="paymentFormData.delayedAmount"
                    [nzMin]="0"
                    [nzStep]="0.01"
                    [nzPrecision]="2"
                    class="w-full"
                    placeholder="Delayed capture amount"
                ></nz-input-number>
            </div>

            <p class="text-sm text-gray-500">
                Current Status:
                <strong>
                    {{
                        paymentStatus
                            ? paymentStatuses[paymentStatus]?.name
                            : 'None'
                    }}
                </strong>
            </p>
        </div>
    </div>
    <div *nzModalFooter class="flex w-full items-center justify-between gap-2">
        <button
            [disabled]="!retriggerStatusAvailable"
            nzTooltip="Retrigger Payment Status"
            nz-button
            type="button"
            (click)="retriggerStatus()"
            class="flex flex-row gap-2 justify-center items-center"
        >
            <i class="fa fa-refresh"></i>
            Retrigger Status
        </button>
        <div class="flex gap-2">
            <button nz-button type="button" (click)="closeModal()">
                Cancel
            </button>
            <button
                nz-button
                nzType="primary"
                type="button"
                (click)="confirmUpdate()"
            >
                Update
            </button>
        </div>
    </div>
</nz-modal>
